import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import '../App.css'; 
import './Rapports.css'; 
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {AddRapportsTwin} from '../Redux/Actions/RapportTwinAction';
import { current } from "../Redux/Actions/AuthActions";

const RapportsTwin = () => {
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(current())
  },[dispatch])

  const user = useSelector((state) => state.AuthReducer.user);
  
  const [emplacement, setEmplacement] = useState('');

  // 🔹 Définir l'emplacement par défaut basé sur la localisation de l'utilisateur
  useEffect(() => {
    if (user && !emplacement) {
      if (user.localisation) {
        setEmplacement(user.localisation);
      } else if (user.assignedLocations && user.assignedLocations.length > 0) {
        // Si on a des IDs, on pourrait avoir besoin de fetch le nom, 
        // mais souvent user.localisation contient le nom par défaut
        // Pour l'instant on privilégie user.localisation
      }
    }
  }, [user, emplacement]);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [playZoneStandardCash, setPlayZoneStandardCash] = useState(0);
  const [playZoneStandardTpe, setPlayZoneStandardTpe] = useState(0);
  const [playZoneSurveilléCash, setPlayZoneSurveilléCash] = useState(0);
  const [playZoneSurveilléTpe, setPlayZoneSurveilléTpe] = useState(0);
  const [accesParentCash, setAccesParentCash] = useState(0);
  const [accesParentTpe, setAccesParentTpe] = useState(0);
  const [packQRCash, setPackQRCash] = useState(0);
  const [packQRTpe, setPackQRTpe] = useState(0);
  const [rechargeQRCash, setRechargeQRCash] = useState(0);
  const [rechargeQRTpe, setRechargeQRTpe] = useState(0);
  const [packCardCash, setPackCardCash] = useState(0);
  const [packCardTpe, setPackCardTpe] = useState(0);
  const [rechargeCardCash, setRechargeCardCash] = useState(0);
  const [rechargeCardTpe, setRechargeCardTpe] = useState(0);
  const [twinClubCash, setTwinClubCash] = useState(0);
  const [twinClubTpe, setTwinClubTpe] = useState(0);
  const [twinToysCash, setTwinToysCash] = useState(0);
  const [twinToysTpe, setTwinToysTpe] = useState(0);
  const [challengeGamesCash, setChallengeGamesCash] = useState(0);
  const [challengeGamesTpe, setChallengeGamesTpe] = useState(0);
  const [candyBarCash, setCandyBarCash] = useState(0);
  const [candyBarTpe, setCandyBarTpe] = useState(0);
  const [packAnnifCash, setPackAnnifCash] = useState(0);
  const [packAnnifTpe, setPackAnnifTpe] = useState(0);

  const [taxiExpense, setTaxiExpense] = useState(0);
  const [repairExpense, setRepairExpense] = useState(0);
  const [advanceExpense, setAdvanceExpense] = useState(0);
  const [miscExpense, setMiscExpense] = useState(0);
  const [otherExpense, setOtherExpense] = useState(0);
  
  const [explanation, setExplanation] = useState('');
  const [showTpeModal, setShowTpeModal] = useState(false);

  const handleCloseTpeModal = () => setShowTpeModal(false);
  const handleShowTpeModal = () => setShowTpeModal(true);

  const navigate = useNavigate();

  const calculateTotalAmount = () => {
    return (
      parseFloat(playZoneStandardCash || 0) + parseFloat(playZoneStandardTpe || 0) +
      parseFloat(playZoneSurveilléCash || 0) + parseFloat(playZoneSurveilléTpe || 0) +
      parseFloat(accesParentCash || 0) + parseFloat(accesParentTpe || 0) +
      parseFloat(packQRCash || 0) + parseFloat(packQRTpe || 0) +
      parseFloat(rechargeQRCash || 0) + parseFloat(rechargeQRTpe || 0) +
      parseFloat(packCardCash || 0) + parseFloat(packCardTpe || 0) +
      parseFloat(rechargeCardCash || 0) + parseFloat(rechargeCardTpe || 0) +
      parseFloat(twinClubCash || 0) + parseFloat(twinClubTpe || 0) +
      parseFloat(twinToysCash || 0) + parseFloat(twinToysTpe || 0) +
      parseFloat(challengeGamesCash || 0) + parseFloat(challengeGamesTpe || 0) +
      parseFloat(candyBarCash || 0) + parseFloat(candyBarTpe || 0) +
      parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0)
    ).toFixed(3);
  };

  const calculateTotalTPE = () => {
    return (
      parseFloat(playZoneStandardTpe || 0) +
      parseFloat(playZoneSurveilléTpe || 0) +
      parseFloat(accesParentTpe || 0) +
      parseFloat(packQRTpe || 0) +
      parseFloat(rechargeQRTpe || 0) +
      parseFloat(packCardTpe || 0) +
      parseFloat(rechargeCardTpe || 0) +
      parseFloat(twinClubTpe || 0) +
      parseFloat(twinToysTpe || 0) +
      parseFloat(challengeGamesTpe || 0) +
      parseFloat(candyBarTpe || 0) +
      parseFloat(packAnnifTpe || 0)
    ).toFixed(3);
  };

  const calculateTotalExpenses = () => {
    return (
      parseFloat(taxiExpense || 0) +
      parseFloat(repairExpense || 0) +
      parseFloat(advanceExpense || 0) +
      parseFloat(miscExpense || 0) +
      parseFloat(otherExpense || 0)
    ).toFixed(3);
  };

  const handleNumberInput = (e, setState) => {
    const value = e.target.value;
    if (/^\d*\.?\d{0,3}$/.test(value)) {
      setState(value);
    }
  };

  const existingReports = useSelector((state) => state.RapportTwinReducer.rapportsTwin || []);

  const handleRapportTwin = (e) => {
      e.preventDefault();
  
      if (!emplacement || !date || !explanation) {
          alert("Veuillez remplir tous les champs correctement.");
          return;
      }
  
      const duplicateReport = existingReports.find(
          (report) =>
              report.localisation === emplacement &&
              report.DateCollect === date
      );
  
      if (duplicateReport) {
          alert("Un rapport pour cette localisation et cette date existe déjà.");
          return;
      }
  
      const confirmSubmit = window.confirm("Voulez-vous confirmer les informations saisies ?");
      if (!confirmSubmit) {
          return;
      }
  
      const rapportData = {
          DateCollect: date.slice(0, 10),
          localisation: emplacement,
          PlayZoneStandard: parseFloat(playZoneStandardCash || 0) + parseFloat(playZoneStandardTpe || 0),
          PlayZoneSurveillé: parseFloat(playZoneSurveilléCash || 0) + parseFloat(playZoneSurveilléTpe || 0),
          AccesParent: parseFloat(accesParentCash || 0) + parseFloat(accesParentTpe || 0),
          PackQR: parseFloat(packQRCash || 0) + parseFloat(packQRTpe || 0),
          RechargeQR: parseFloat(rechargeQRCash || 0) + parseFloat(rechargeQRTpe || 0),
          PackCard: parseFloat(packCardCash || 0) + parseFloat(packCardTpe || 0),
          RechargeCard: parseFloat(rechargeCardCash || 0) + parseFloat(rechargeCardTpe || 0),
          TwinClub: parseFloat(twinClubCash || 0) + parseFloat(twinClubTpe || 0),
          TwinToys: parseFloat(twinToysCash || 0) + parseFloat(twinToysTpe || 0),
          ChallengeGames: parseFloat(challengeGamesCash || 0) + parseFloat(challengeGamesTpe || 0),
          CandyBar: parseFloat(candyBarCash || 0) + parseFloat(candyBarTpe || 0),
          PackAnnif: parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0),
          TotalAmount: parseFloat(calculateTotalAmount()),
          TotalTpe: parseFloat(calculateTotalTPE()),
          DailyExpenses: parseFloat(calculateTotalExpenses()),
          TaxiExpenses: parseFloat(taxiExpense || 0),
          RepairExpenses: parseFloat(repairExpense || 0),
          StaffAdvance: parseFloat(advanceExpense || 0),
          MiscPurchases: parseFloat(miscExpense || 0),
          OtherExpenses: parseFloat(otherExpense || 0),
          feedback: explanation,
          owner: user._id,
      };
  
      dispatch(AddRapportsTwin(rapportData, navigate));
  };
  

  return (
    <div className="list-rapports">   
      <h3>Rapport Twin Park</h3>

    <Form className="rapport-form" onSubmit={handleRapportTwin}>
      <Row className="mb-3">
        <Form.Group as={Col} controlId="formGridState" className="rapport-form-group">
          <Form.Label>Emplacement</Form.Label>
          <Form.Select 
            onChange={(e) => setEmplacement(e.target.value)} 
            className="rapport-select" 
            value={emplacement || "Choisissez un emplacement..."}>
            <option disabled value="Choisissez un emplacement...">Choisissez un emplacement...</option>
            <option>Twin Park- Manar City</option>
            <option>Twin Park - Tunisia Mall</option>
            <option>Twin park - Jardins d'eL Menzah</option>
            <option>Jump Zone Mall of Djerba</option>
          </Form.Select>
        </Form.Group>
          
        <Form.Group as={Col} controlId="formGridDate" className="rapport-form-group">
      <Form.Label>Date du jour</Form.Label>
      <Form.Control 
        type="date" 
        className="rapport-input" 
        value={date} 
        onChange={(e) => setDate(e.target.value)}
        readOnly={user?.role !== 'admin'} // Rend le champ modifiable uniquement pour l'admin
      />
        </Form.Group>
      </Row>
      <div className="section-header">
        <h4>Recettes (Espèces)</h4>
        <Button onClick={handleShowTpeModal} className="tpe-modal-btn">
          💳 Paiements TPE
        </Button>
      </div>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formPlayZoneStandard" className="rapport-form-group">
          <Form.Label>PlayZone Standard</Form.Label>
          <Form.Control 
            type="text" 
            value={playZoneStandardCash}
            onChange={(e) => handleNumberInput(e, setPlayZoneStandardCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formPlayZoneSurveillé" className="rapport-form-group">
          <Form.Label>PlayZone Surveillé</Form.Label>
          <Form.Control 
            type="text" 
            value={playZoneSurveilléCash}
            onChange={(e) => handleNumberInput(e, setPlayZoneSurveilléCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formAccesParent" className="rapport-form-group">
          <Form.Label>Accès Parents</Form.Label>
          <Form.Control 
            type="text" 
            value={accesParentCash}
            onChange={(e) => handleNumberInput(e, setAccesParentCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formPackQR" className="rapport-form-group">
          <Form.Label>Pack QR</Form.Label>
          <Form.Control 
            type="text" 
            value={packQRCash}
            onChange={(e) => handleNumberInput(e, setPackQRCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formRechargeQR" className="rapport-form-group">
          <Form.Label>Recharge QR</Form.Label>
          <Form.Control 
            type="text" 
            value={rechargeQRCash}
            onChange={(e) => handleNumberInput(e, setRechargeQRCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formPackCard" className="rapport-form-group">
          <Form.Label>Pack Card</Form.Label>
          <Form.Control 
            type="text" 
            value={packCardCash}
            onChange={(e) => handleNumberInput(e, setPackCardCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formRechargeCard" className="rapport-form-group">
          <Form.Label>Recharge Card</Form.Label>
          <Form.Control 
            type="text" 
            value={rechargeCardCash}
            onChange={(e) => handleNumberInput(e, setRechargeCardCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      
        <Form.Group as={Col} controlId="formTwinToys" className="rapport-form-group">
          <Form.Label>Twin Toys</Form.Label>
          <Form.Control 
            type="text" 
            value={twinToysCash}
            onChange={(e) => handleNumberInput(e, setTwinToysCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formTwinClub" className="rapport-form-group">
          <Form.Label>Twin Club</Form.Label>
          <Form.Control 
            type="text" 
            value={twinClubCash}
            onChange={(e) => handleNumberInput(e, setTwinClubCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formChallengeGames" className="rapport-form-group">
          <Form.Label>Challenge Games</Form.Label>
          <Form.Control 
            type="text" 
            value={challengeGamesCash}
            onChange={(e) => handleNumberInput(e, setChallengeGamesCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formCandyBar" className="rapport-form-group">
          <Form.Label>Candy Bar</Form.Label>
          <Form.Control 
            type="text" 
            value={candyBarCash}
            onChange={(e) => handleNumberInput(e, setCandyBarCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formPackAnnif" className="rapport-form-group">
          <Form.Label>Pack Anniversaire</Form.Label>
          <Form.Control 
            type="text" 
            value={packAnnifCash}
            onChange={(e) => handleNumberInput(e, setPackAnnifCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      {/* Modal for TPE Payments */}
      <Modal show={showTpeModal} onHide={handleCloseTpeModal} size="lg" centered className="tpe-modal">
        <Modal.Header closeButton>
          <Modal.Title>Saisie des Paiements TPE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-4">Saisissez les montants payés par TPE pour chaque rubrique.</p>
          <Row>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>PlayZone Standard</Form.Label>
              <Form.Control type="text" value={playZoneStandardTpe} onChange={(e) => handleNumberInput(e, setPlayZoneStandardTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>PlayZone Surveillé</Form.Label>
              <Form.Control type="text" value={playZoneSurveilléTpe} onChange={(e) => handleNumberInput(e, setPlayZoneSurveilléTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Accès Parents</Form.Label>
              <Form.Control type="text" value={accesParentTpe} onChange={(e) => handleNumberInput(e, setAccesParentTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Pack QR</Form.Label>
              <Form.Control type="text" value={packQRTpe} onChange={(e) => handleNumberInput(e, setPackQRTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Recharge QR</Form.Label>
              <Form.Control type="text" value={rechargeQRTpe} onChange={(e) => handleNumberInput(e, setRechargeQRTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Pack Card</Form.Label>
              <Form.Control type="text" value={packCardTpe} onChange={(e) => handleNumberInput(e, setPackCardTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Recharge Card</Form.Label>
              <Form.Control type="text" value={rechargeCardTpe} onChange={(e) => handleNumberInput(e, setRechargeCardTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Twin Toys</Form.Label>
              <Form.Control type="text" value={twinToysTpe} onChange={(e) => handleNumberInput(e, setTwinToysTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Twin Club</Form.Label>
              <Form.Control type="text" value={twinClubTpe} onChange={(e) => handleNumberInput(e, setTwinClubTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Challenge Games</Form.Label>
              <Form.Control type="text" value={challengeGamesTpe} onChange={(e) => handleNumberInput(e, setChallengeGamesTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Candy Bar</Form.Label>
              <Form.Control type="text" value={candyBarTpe} onChange={(e) => handleNumberInput(e, setCandyBarTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Pack Anniversaire</Form.Label>
              <Form.Control type="text" value={packAnnifTpe} onChange={(e) => handleNumberInput(e, setPackAnnifTpe)} placeholder="0.000 DT" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseTpeModal}>Confirmer</Button>
        </Modal.Footer>
      </Modal>

      <hr />
      <h5>Dépenses Détailées</h5>
      <Row>
        <Form.Group as={Col} controlId="formTaxiExpense" className="rapport-form-group">
          <Form.Label>Frais de Taxi</Form.Label>
          <Form.Control 
            type="text" 
            value={taxiExpense}
            onChange={(e) => handleNumberInput(e, setTaxiExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formRepairExpense" className="rapport-form-group">
          <Form.Label>Frais de Réparation</Form.Label>
          <Form.Control 
            type="text" 
            value={repairExpense}
            onChange={(e) => handleNumberInput(e, setRepairExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formAdvanceExpense" className="rapport-form-group">
          <Form.Label>Avance Personnel</Form.Label>
          <Form.Control 
            type="text" 
            value={advanceExpense}
            onChange={(e) => handleNumberInput(e, setAdvanceExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} controlId="formMiscExpense" className="rapport-form-group">
          <Form.Label>Achats Divers</Form.Label>
          <Form.Control 
            type="text" 
            value={miscExpense}
            onChange={(e) => handleNumberInput(e, setMiscExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formOtherExpense" className="rapport-form-group">
          <Form.Label>Autres</Form.Label>
          <Form.Control 
            type="text" 
            value={otherExpense}
            onChange={(e) => handleNumberInput(e, setOtherExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>
        <Col></Col>
      </Row>

      <hr />
      <Row>
        <Form.Group as={Col} controlId="formGridAmount" className="rapport-form-group">
          <Form.Label>Montant Total</Form.Label>
          <Form.Control 
            value={calculateTotalAmount()}
            readOnly
            type="text" 
            className="rapport-input" 
          />
        </Form.Group>
      
        <Form.Group as={Col} controlId="formGridExpense" className="rapport-form-group">
          <Form.Label>Dépenses Total</Form.Label>
          <Form.Control 
            value={calculateTotalExpenses()}
            readOnly
            type="text" 
            className="rapport-input" 
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} controlId="formGridDifference" className="rapport-form-group">
          <Form.Label>Différence (Total - Dépenses)</Form.Label>
          <Form.Control 
            value={(parseFloat(calculateTotalAmount()) - parseFloat(calculateTotalExpenses())).toFixed(3)}
            readOnly
            type="text" 
            className="rapport-input" 
            style={{ fontWeight: 'bold', color: 'blue' }}
          />
          <Form.Text className="text-muted">
            Dont TPE: {calculateTotalTPE()} TND
          </Form.Text>
        </Form.Group>
      </Row>

        <Form.Group as={Col} controlId="formExplanation" className="rapport-form-group">
          <Form.Label>Explication</Form.Label>
          <Form.Control 
            as="textarea" 
            rows={2} 
            onChange={(e) => setExplanation(e.target.value)} 
            placeholder="Entrez une explication"
          />
        </Form.Group>
      

        <Button 
  onClick={(e) => handleRapportTwin(e)} variant="primary" type="submit" className="rapport-button"
>
  Soumettre
</Button>
    </Form>
    </div>
  );
};

export default RapportsTwin;
